import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import FooterTabBarLayout from '../../layouts/FooterTabBarLayout';
import HeaderBar from '../../layouts/HeaderBar';
import MeetingContainer from '../../containers/MeetingContainer';
import { getMeetingList } from '../../../api/MeetingApi';
import useLoadingStore from '../../../store/loadingStore';
import { IoRefreshOutline, IoAdd, IoRestaurantOutline, IoSearchOutline } from 'react-icons/io5';
import NotificationIcon from '../../layouts/NotificationIcon';
import useAuthStore from "../../../store/authStore";
import { AlertModal } from '../../layouts/AlertModal';


const MeetingListPage = () => {
  const navigate = useNavigate();
  const [meetings, setMeetings] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const { setIsLoading } = useLoadingStore();
  const {member, checkAuth} = useAuthStore();
  const [alertState, setAlertState] = useState({ isVisible: false, message: '' });

  const fetchMeetings = async (isInitial = false) => {
    setIsLoading(true);

    const response = await getMeetingList(
      member.latitude,
      member.longitude,
      isInitial ? null : meetings[meetings.length - 1]?.createdAt
    );

    setMeetings(prev => isInitial ? response.meetingListDtoList : [...prev, ...response.meetingListDtoList]);
    setHasMore(response.hasMore);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchMeetings(true);
  }, []);

  const handleMeetingClick = (meetingId) => {
    navigate(`/app/meetings/${meetingId}`);
  };

  const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return {
      time: date.toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' }),
      date: date.toLocaleDateString('ko-KR', { month: 'numeric', day: 'numeric' })
    };
  };

  // 헤더 오른쪽 아이콘 설정
  const rightIcons = [
    {
      icon: <IoRefreshOutline size={24} className="text-gray-600" />,
      onClick: () => fetchMeetings(true),
      title: '새로고침'
    },
    {
      icon: <IoSearchOutline size={24} className="text-gray-600" />,
      onClick: () => navigate('/app/search'),
      title: '검색'
    },
    {
      icon: <NotificationIcon />,
      onClick: () => {},
      title: '알림'
    }
  ];

  return (
    <FooterTabBarLayout>
      <HeaderBar
        title="모임 목록"
        rightIcons={rightIcons}
      />

      <div className="p-4 max-w-lg mx-auto">
        <AlertModal
          isVisible={alertState.isVisible}
          message={alertState.message}
          onClose={() => setAlertState({ isVisible: false, message: '' })}
        />
        {meetings.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-16">
            <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mb-6">
              <IoRestaurantOutline size={40} className="text-amber-500" />
            </div>
            <p className="text-gray-600 text-lg font-medium mb-2">주변에 모임이 없습니다</p>
            <p className="text-gray-500 text-sm text-center">
              새로운 모임을 만들어보세요!<br />
              밥친구들이 기다리고 있어요
            </p>
          </div>
        ) : (
          <div className="space-y-4">
              {meetings.map(meeting => {
                const dateTime = formatDate(meeting.scheduledAt);
                return (
                  <MeetingContainer
                    key={meeting.meetingId}
                    title={meeting.title}
                    imageId={meeting.imageId}
                    imageUrl={meeting.imageUrl}
                    location={meeting.placeName}
                    currentMembers={meeting.memberCount}
                    maxMembers={meeting.maxCapacity}
                    time={dateTime?.time}
                    date={dateTime?.date}
                    status={meeting.status}
                    onClick={() => handleMeetingClick(meeting.meetingId)}
                  />
                );
              })}

            {/* 더보기 버튼 */}
            {hasMore && (
              <div className="pt-4">
                <button
                  onClick={() => fetchMeetings()}
                  className="w-full py-3 bg-white border border-gray-300 rounded-lg text-gray-700 active:bg-gray-50"
                >
                  더보기
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      {/* 플로팅 액션 버튼 */}
      <button
        onClick={async () => {
          await checkAuth();
          const latestMember = useAuthStore.getState().member;
          const balance = latestMember?.riceBalance ?? member?.riceBalance ?? 0;
          if (!latestMember || balance >= 500) {
            navigate('/app/create-meeting');
          } else {
            setAlertState({ isVisible: true, message: '쌀이 부족합니다. 쌀을 충전해 주세요' });
          }
        }}
        className="fixed right-4 bottom-24 w-14 h-14 bg-amber-500 rounded-full flex items-center justify-center active:bg-amber-600 transition-colors z-10"
      >
        <IoAdd size={24} className="text-white" />
      </button>
    </FooterTabBarLayout>
  );
};

export default MeetingListPage;
